export const fa = {
    nav: {
        dashboard: 'داشبورد',
        board: 'تابلو',
        list: 'لیست',
        settings: 'تنظیمات',
        reports: 'گزارش‌ها',
        myTasks: 'وظایف من',
        activity: 'فعالیت',
        charts: 'نمودارها',
        team: 'تیم',
        timeTracking: 'پیگیری زمان',
        admin: 'مدیریت',
        adminOverview: 'نمای کلی مدیریت',
        userManagement: 'مدیریت کاربران',
        projectSetup: 'راه‌اندازی پروژه',
    },
    common: {
        projectManMD: 'ProjectManMD',
        markdownProjectManagement: 'مدیریت پروژه مارک‌داون',
        version: 'نسخه',
        back: 'بازگشت',
        loading: 'در حال بارگذاری...',
        noData: 'بدون داده',
        search: 'جستجو',
        filter: 'فیلتر',
        all: 'همه',
        close: 'بستن',
        open: 'باز کردن',
        connect: 'اتصال',
        archived: 'بایگانی شده',
        inactive: 'غیرفعال',
        active: 'فعال',
        untitled: 'بدون عنوان',
        unknown: 'نامشخص',
        tasks: 'وظایف',
        done: 'انجام شده',
        lastModified: 'آخرین تغییر',
        created: 'ایجاد شده',
        points: 'امتیازات',
        pts: 'امت',
        yes: 'بله',
        no: 'خیر',
        or: 'یا',
    },
    actions: {
        create: 'ایجاد',
        edit: 'ویرایش',
        delete: 'حذف',
        save: 'ذخیره',
        cancel: 'لغو',
        confirm: 'تأیید',
        add: 'افزودن',
        remove: 'حذف',
        update: 'به‌روزرسانی',
        close: 'بستن',
        submit: 'ارسال',
        reset: 'بازنشانی',
        load: 'بارگذاری',
        export: 'خروجی',
        import: 'ورودی',
        archive: 'بایگانی',
        restore: 'بازیابی',
        deactivate: 'غیرفعال کردن',
        activate: 'فعال کردن',
    },
    auth: {
        signIn: 'ورود',
        signOut: 'خروج',
        signUp: 'ثبت‌نام',
        username: 'نام کاربری',
        password: 'رمز عبور',
        confirmPassword: 'تأیید رمز عبور',
        displayName: 'نام نمایشی',
        email: 'ایمیل',
        role: 'نقش',
        createAccount: 'ایجاد حساب کاربری',
        dontHaveAccount: 'حساب کاربری ندارید؟',
        alreadyHaveAccount: 'قبلاً حساب کاربری دارید؟',
        signInToAccount: 'به حساب کاربری خود وارد شوید',
        createYourAccount: 'حساب کاربری خود را ایجاد کنید',
        enterUsername: 'نام کاربری خود را وارد کنید',
        enterPassword: 'رمز عبور خود را وارد کنید',
        chooseUsername: 'یک نام کاربری انتخاب کنید',
        yourFullName: 'نام کامل شما',
        atLeast6Chars: 'حداقل ۶ کاراکتر',
        confirmPasswordPlaceholder: 'رمز عبور خود را تأیید کنید',
        pleaseEnterCredentials: 'لطفاً نام کاربری و رمز عبور را وارد کنید',
        invalidCredentials: 'نام کاربری یا رمز عبور نامعتبر است',
        pleaseFillAllFields: 'لطفاً تمام فیلدها را پر کنید',
        passwordsDoNotMatch: 'رمزهای عبور مطابقت ندارند',
        passwordTooShort: 'رمز عبور باید حداقل ۶ کاراکتر باشد',
        usernameExists: 'نام کاربری قبلاً وجود دارد',
        demoCredentials: 'اطلاعات ورود نمونه',
        admin: 'مدیر',
        manager: 'مدیر پروژه',
        developer: 'توسعه‌دهنده',
        viewer: 'بیننده',
        contactAdminForRole: 'برای تغییر نقش با مدیر تماس بگیرید',
        usernameCannotBeChanged: 'نام کاربری قابل تغییر نیست',
    },
    statuses: {
        backlog: 'عقب‌افتاده',
        todo: 'انجام دادن',
        inProgress: 'در حال انجام',
        inReview: 'در حال بررسی',
        done: 'انجام شده',
        planned: 'برنامه‌ریزی شده',
        inProgressSprint: 'در حال انجام (اسپرینت)',
        completed: 'تکمیل شده',
        allStatus: 'همه وضعیت‌ها',
    },
    priorities: {
        critical: 'بحرانی',
        high: 'بالا',
        medium: 'متوسط',
        low: 'پایین',
    },
    messages: {
        noProjects: 'هنوز پروژه‌ای وجود ندارد',
        noTasks: 'بدون وظیفه',
        confirmDelete: 'آیا مطمئن هستید که می‌خواهید این را حذف کنید؟',
        saved: 'با موفقیت ذخیره شد',
        error: 'خطایی رخ داد',
        noTasksAssigned: 'هیچ وظیفه‌ای به شما اختصاص داده نشده',
        noActivityYet: 'هنوز فعالیتی وجود ندارد',
        confirmReset: 'این کار تمام داده‌ها را به حالت اولیه بازمی‌گرداند. ادامه می‌دهید؟',
        removeUserConfirm: 'آیا مطمئن هستید که می‌خواهید این کاربر را حذف کنید؟',
        deleteProjectConfirm: 'آیا مطمئن هستید که می‌خواهید این پروژه را حذف کنید؟',
        archiveProjectConfirm: 'آیا مطمئن هستید که می‌خواهید این پروژه را بایگانی کنید؟',
    },
    settings: {
        title: 'تنظیمات',
        theme: 'پوسته',
        language: 'زبان',
        languageAndRegion: 'زبان و منطقه',
        gitConfig: 'پیکربندی گیت',
        gitIntegration: 'یکپارچه‌سازی گیت',
        gitProvider: 'ارائه‌دهنده گیت',
        repositoryUrl: 'آدرس مخزن',
        seedData: 'داده نمونه',
        seedDataDescription: 'پروژه‌های نمونه با وظایف، اسپرینت‌ها و اپیک‌ها را برای آزمایش بارگذاری کنید. این کار تمام داده‌ها را به حالت اولیه بازمی‌گرداند.',
        loadSeedData: 'بارگذاری داده نمونه',
        seedDataConfirm: 'این کار تمام داده‌ها را به حالت اولیه بازمی‌گرداند. ادامه می‌دهید؟',
        appearance: 'ظاهر',
        notifications: 'اعلان‌ها',
    },
    themes: {
        summer: 'تابستان',
        spring: 'بهار',
        autumn: 'پاییز',
        winter: 'زمستان',
        day: 'روز',
        night: 'شب',
        summerDay: 'روز تابستانی',
        summerNight: 'شب تابستانی',
        springDay: 'روز بهاری',
        springNight: 'شب بهاری',
        autumnDay: 'روز پاییزی',
        autumnNight: 'شب پاییزی',
        winterDay: 'روز زمستانی',
        winterNight: 'شب زمستانی',
        highContrast: 'کنتراست بالا',
        selectTheme: 'انتخاب پوسته',
    },
    time: {
        hours: 'ساعت',
        minutes: 'دقیقه',
        days: 'روز',
        weeks: 'هفته',
        justNow: 'همین الان',
        minutesAgo: '{{count}} دقیقه پیش',
        hoursAgo: '{{count}} ساعت پیش',
        daysAgo: '{{count}} روز پیش',
        updatedAt: 'به‌روزرسانی شده',
    },
    reports: {
        velocity: 'سرعت',
        burndown: 'نمودار سوختن',
        burnup: 'نمودار افزایش',
        cycleTime: 'زمان چرخه',
        leadTime: 'زمان انتظار',
        throughput: 'تولید',
        gantt: 'گانت',
        cumulativeFlow: 'جریان تجمعی',
    },
    globalSearch: {
        placeholder: 'جستجوی پروژه‌ها، وظایف، اسپرینت‌ها...',
        noResults: 'نتیجه‌ای یافت نشد',
        projects: 'پروژه‌ها',
        tasks: 'وظایف',
        sprints: 'اسپرینت‌ها',
        epics: 'اپیک‌ها',
    },
    notifications: {
        title: 'اعلان‌ها',
        markAllRead: 'علامت همه به عنوان خوانده شده',
        clearAll: 'پاک کردن همه',
        empty: 'بدون اعلان',
        unread: '{count} خوانده نشده',
    },
    dashboard: {
        totalProjects: 'کل پروژه‌ها',
        totalTasks: 'کل وظایف',
        completion: 'تکمیل',
        statusBreakdown: 'تفکیک وضعیت',
        createProject: 'ایجاد پروژه',
        loadSeedData: 'بارگذاری داده نمونه',
        noProjects: 'هنوز پروژه‌ای وجود ندارد',
        getStarted: 'با ایجاد پروژه جدید یا بارگذاری داده نمونه شروع کنید.',
        projects: 'پروژه‌ها',
        newProject: 'پروژه جدید',
        createNewProject: 'ایجاد پروژه جدید',
        projectName: 'نام پروژه',
        description: 'توضیحات',
        workflow: 'گردش کار',
        skipToMain: 'رفتن به محتوای اصلی',
        projectProgress: 'پیشرفت پروژه',
        quickActions: 'Quick Actions',
        manageTasks: 'Manage tasks and track progress',
        trackTime: 'Track time for your tasks',
    },
    calendar: {
        jalali: 'جلالی',
        hijri: 'هجری',
        gregorian: 'میلادی',
    },
    accessibility: {
        skipToMain: 'رفتن به محتوای اصلی',
        board: 'تابلوی وظایف',
        projectList: 'لیست پروژه‌ها',
        mainNav: 'ناوبری اصلی',
        selectTheme: 'انتخاب پوسته',
        projectDashboard: 'داشبورد پروژه',
        toggleSidebar: 'Toggle sidebar',
    },
    board: {
        title: 'تابلو',
        kanban: 'کانبان',
        scrum: 'اسکرام',
    },
    task: {
        title: 'وظیفه',
        createTask: 'ایجاد وظیفه',
        editTask: 'ویرایش وظیفه',
        deleteTask: 'حذف وظیفه',
        assignee: 'مسئول',
        unassigned: 'بدون مسئول',
        storyPoints: 'امتیازات داستان',
        labels: 'برچسب‌ها',
        description: 'توضیحات',
        acceptanceCriteria: 'معیارهای پذیرش',
        timeLog: 'گزارش زمان',
        comments: 'نظرات',
        addComment: 'افزودن نظر',
        noComments: 'هنوز نظری وجود ندارد',
        status: 'وضعیت',
        priority: 'اولویت',
        created: 'ایجاد شده',
        updated: 'به‌روزرسانی شده',
        started: 'شروع شده',
    },
    sprint: {
        title: 'اسپرینت',
        createSprint: 'ایجاد اسپرینت',
        sprintGoal: 'هدف اسپرینت',
        committedPoints: 'امتیازات تعهد شده',
        completedPoints: 'امتیازات تکمیل شده',
        velocity: 'سرعت',
        planned: 'برنامه‌ریزی شده',
        inProgress: 'در حال انجام',
        completed: 'تکمیل شده',
    },
    team: {
        title: 'تیم',
        members: 'اعضا',
        role: 'نقش',
        availability: 'در دسترس بودن',
        assignedTasks: 'وظایف اختصاص داده شده',
        activeTasks: 'وظایف فعال',
        doneTasks: 'وظایف انجام شده',
    },
    timeTracking: {
        title: 'پیگیری زمان',
        timer: 'زمان‌سنج',
        manualEntry: 'ورودی دستی',
        startTime: 'زمان شروع',
        stopTime: 'زمان توقف',
        duration: 'مدت زمان',
        date: 'تاریخ',
        totalHours: 'کل ساعات',
        entries: 'ورودی‌ها',
        noEntries: 'هنوز وردیی وجود ندارد',
        hours: 'Hours',
        minutes: 'Minutes',
    },
    admin: {
        dashboard: 'داشبورد مدیریت',
        projects: 'پروژه‌ها',
        totalTasks: 'کل وظایف',
        storyPoints: 'امتیازات داستان',
        taskStatusBreakdown: 'تفکیک وضعیت وظایف',
        projectProgress: 'پیشرفت پروژه',
        teamWorkload: 'بار کاری تیم',
        assigned: 'اختصاص داده شده',
        active: 'فعال',
    },
    myTasks: {
        title: 'وظایف من',
        total: 'کل',
        inProgress: 'در حال انجام',
        inReview: 'در حال بررسی',
        done: 'انجام شده',
        completion: 'تکمیل',
        allStatus: 'همه وضعیت‌ها',
        allProjects: 'همه پروژه‌ها',
        noTasksAssigned: 'هیچ وظیفه‌ای به شما اختصاص داده نشده',
    },
    activity: {
        title: 'فید فعالیت',
        commentsOnYourTasks: 'نظرات روی وظایف شما',
        allActivity: 'همه فعالیت‌ها',
        noActivityYet: 'هنوز فعالیتی وجود ندارد',
        commentedOn: 'نظر داد در مورد',
        movedTo: 'جابجا شد به',
    },
    profile: {
        title: 'پروفایل',
        avatar: 'آواتار',
        dragDropImage: 'تصویر را اینجا رها کنید یا فایل را مرور کنید',
        browse: 'مرور',
        imageFormats: 'PNG، JPG، WEBP حداکثر ۲ مگابایت',
        removePhoto: 'حذف عکس',
        saveChanges: 'ذخیره تغییرات',
        profileSaved: 'پروفایل ذخیره شد',
        contactAdmin: 'برای تغییر نقش با مدیر تماس بگیرید',
    },
};
//# sourceMappingURL=fa.js.map